// @flow
import * as React from 'react';
import Container from './Container';
import ButtonIcon from './ButtonIcon';

import Merchant from '../lib/Merchant';
import { EVENT_TYPES } from '../HOCs/withEventManager';
import type { TVoidActionCreator, TNavigateToActionCreator } from '../reducers';
import type { TNavigationState } from '../reducers/navigation';
import type { TEventDispatch } from '../HOCs/withEventManager';

type TProps = {
  dispatchEvent: TEventDispatch,
  navigation: TNavigationState,
  navigateTo: TNavigateToActionCreator,
  navigateBack: TVoidActionCreator,
  showLogo?: boolean,
  showBack?: boolean,
  showExit?: boolean,
};

export default function TopBar(props: TProps): React.Node {
  const onExit = () => {
    const merchant: ?Merchant = props.navigation.current.state ? props.navigation.current.state.merchant : null;
    if (merchant) props.navigateTo('/exit-confirm', { merchant });
    else props.dispatchEvent(EVENT_TYPES.exit, {});
  };

  return (
    <Container flex fullwidth justify="space-between" height="48px" align="center">
      <Container width="25%" pl={4} py={16} onClick={props.showBack ? props.navigateBack : null}>
        {props.showBack ? <ButtonIcon name="arrow-left" /> : <Container />}
      </Container>
      <Container width="25%" flex centered top={0} py={16}>
        {props.showLogo ? <img alt="logo" height="24px" src="https://s3-us-west-2.amazonaws.com/static.methodfi.com/assets/method-logo.png" /> : <Container />}
      </Container>
      <Container width="25%" pr={4} flex justify="flex-end" py={16} onClick={props.showExit ? onExit : null}>
        {props.showExit ? <ButtonIcon name="x" /> : <Container />}
      </Container>
    </Container>
  );
}
